import { FlexibleBlock, PortalBlock, PortalBlockType } from './portal-block';

interface PortalBlockSizeLimits {
  colsDefault: number;
  rowsDefault: number;
  colsAllowed: number[];
  rowsAllowed: number[];
}

type PortalBlockSizeLimitsProps<T extends PortalBlock> = T extends FlexibleBlock
  ? Pick<FlexibleBlock, 'type' | 'template'>
  : Pick<PortalBlock, 'type'>;

export const getPortalBlockSizeLimits = <T extends PortalBlock>(
  props: PortalBlockSizeLimitsProps<T>
): PortalBlockSizeLimits => {
  const commonLimits = {
    colsDefault: 6,
    colsAllowed: [1, 2, 3, 4, 5, 6],
    rowsDefault: 1,
    rowsAllowed: [1, 2, 3, 4],
  };
  if (props.type === PortalBlockType.INFO) {
    return {
      ...commonLimits,
      colsDefault: 1,
      colsAllowed: [1, 2, 3],
    };
  }
  if (props.type === PortalBlockType.CHAT) {
    return {
      ...commonLimits,
      colsAllowed: [3, 4, 5, 6],
    };
  }
  if (props.type === PortalBlockType.FILES_RECENT) {
    return {
      ...commonLimits,
      colsDefault: 3,
      colsAllowed: [3, 4, 5, 6],
    };
  }
  if (props.type === PortalBlockType.FILES_BUCKET) {
    return {
      ...commonLimits,
      colsDefault: 3,
      colsAllowed: [3, 4, 6],
    };
  }
  if (props.type === PortalBlockType.EMBED) {
    return {
      ...commonLimits,
      colsAllowed: [2, 3, 4, 5, 6],
    };
  }
  if (
    props.type === PortalBlockType.FILES_DASHBOARD ||
    props.type === PortalBlockType.TASKS_DASHBOARD ||
    props.type === PortalBlockType.CHATS_DASHBOARD
  ) {
    return {
      ...commonLimits,
      colsAllowed: [6],
    };
  }
  if (props.type === PortalBlockType.NOTE) {
    return {
      ...commonLimits,
      colsAllowed: [3, 4, 5, 6],
    };
  }
  if (props.type === PortalBlockType.FLEXIBLE) {
    if ('template' in props) {
      if (props.template.type === 'info-card') {
        return {
          colsDefault: 3,
          colsAllowed: [2, 3, 4, 5, 6],
          rowsDefault: 1,
          rowsAllowed: [1, 2, 3, 4],
        };
      }
      if (props.template.type === 'code') {
        return {
          colsDefault: 3,
          colsAllowed: [1, 2, 3, 4, 5, 6],
          rowsDefault: 1,
          rowsAllowed: [1, 2, 3, 4],
        };
      }
      if (props.template.type === 'tiles') {
        return {
          colsDefault: 4,
          colsAllowed: [1, 2, 3, 4, 5, 6],
          rowsDefault: 1,
          rowsAllowed: [1, 2, 3, 4],
        };
      }
      if (props.template.type === 'custom') {
        return {
          colsDefault: 2,
          colsAllowed: [1, 2, 3, 4, 5, 6],
          rowsDefault: 1,
          rowsAllowed: [1, 2, 3, 4],
        };
      }
      if (props.template.type === 'process-state' || props.template.type === 'process-action') {
        return {
          colsDefault: 6,
          colsAllowed: [3, 4, 5, 6],
          rowsDefault: 1,
          rowsAllowed: [1, 2, 3, 4],
        };
      }
      if (props.template.type === 'diagram') {
        return {
          colsDefault: 6,
          colsAllowed: [3, 4, 5, 6],
          rowsDefault: 1,
          rowsAllowed: [1, 2, 3, 4],
        };
      }
    }
    return {
      ...commonLimits,
      colsAllowed: [2, 3, 4, 5, 6],
    };
  }

  return commonLimits;
};
